<template>
  <el-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="添加部件"
      width="600px"
      top="10vh"
      @close="$reset('form')">
    <el-form ref="form" :model="model" :rules="ruleValidate" label-width="90px">
      <el-form-item label="部件名称" prop="partsName">
        <el-input v-model="model.partsName" placeholder="请选择部件" readonly>
          <el-button slot="append" @click="$refs.selectMaterial.open()">选择</el-button>
        </el-input>
        <material-select ref="selectMaterial" @select="selectMaterial"/>
      </el-form-item>
      <el-form-item label="固定工时" prop="fixedWorkingTime">
        <el-input v-model="model.fixedWorkingTime" placeholder="请输入固定工时"/>
      </el-form-item>
      <el-form-item label="变动工时" prop="variableWorkingTime">
        <el-input v-model="model.variableWorkingTime" placeholder="请输入变动工时"/>
      </el-form-item>
      <el-form-item label="是否唯一码" prop="isUniqueSn">
        <el-select v-model="model.isUniqueSn" clearable placeholder="请选择是否唯一码">
          <el-option label="唯一码" :value="true"/>
          <el-option label="自制条码" :value="false"/>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  export default {
    components: { MaterialSelect },
    data() {
      return {
        dialogVisible: false,
        ruleValidate: {
          partsName: { required: true, message: "请选择物料", trigger: "change" },
          fixedWorkingTime: { required: true, message: "请输入固定工时", trigger: "blur" },
          variableWorkingTime: { required: true, message: "请输入变动工时", trigger: "blur" },
          isUniqueSn: { required: true, message: "请选择是否唯一码", trigger: "change" },
        },
        model: {
          partsName: "",
          partsNo: "",
          fixedWorkingTime: "",
          variableWorkingTime: "",
          isUniqueSn: "",
        },
      };
    },

    methods: {
      open() {
        this.dialogVisible = true;
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.dialogVisible = false;
            this.$emit("partsSave", this.model);
          }
        });
      },

      selectMaterial(row) {
        this.model.partsName = row.materialName;
        this.model.partsNo = row.materialNO;
      },
    },
  };
</script>
